// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"ebf0a904287e8b10dce3","6980":"2b13d8d1a6ab6dbd0edd"}[chunkId] + ".js";
};